export enum PaySupplementType {
  Holiday = 'Holiday',
  Night = 'Night',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}
